


































































































import {Vue, Component, Prop, Emit, Ref} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {Mall} from 'supporter';
import {addDay, getToday} from '@/utils/dateUtils';
import ClickOutside from 'vue-click-outside';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import MallSelect from '@/components/common/claim/contentTop/MallSelect.vue';
import PartnerInput from '@/components/common/claim/contentTop/PartnerInput.vue';
import OrderRegisterTypeSelect from '@/components/common/claim/contentTop/OrderRegisterTypeSelect.vue';
import DelayCount from '@/components/common/claim/contentTop/DelayCount.vue'
import MemberGroupSelect from '@/components/common/claim/contentTop/MemberGroupSelect.vue';
import SearchWordSelect from '@/components/common/claim/contentTop/SearchWordSelect.vue';
import SearchDateType from '@/components/common/claim/contentTop/SearchDateType.vue';
import PayTypeCheckList from '@/components/common/claim/contentTop/PayTypeCheckList.vue';
import PlatformTypeCheckList from '@/components/common/claim/contentTop/PlatformTypeCheckList.vue';
import ClaimStatusCheckList from '@/components/common/claim/contentTop/ClaimStatusCheckList.vue';
import ShippingAreaTypeSelect from '@/components/common/claim/contentTop/ShippingAreaTypeSelect.vue';
import TaskMessageSearchTypeSelect from '@/components/common/claim/contentTop/TaskMessageSearchTypeSelect.vue';
import {ClaimType} from '@/types/claim';

@Component({
  components: {
    ClaimStatusCheckList,
    SearchWordSelect,
    MallSelect,
    PartnerInput,
    OrderRegisterTypeSelect,
    DelayCount,
    MemberGroupSelect,
    SearchDateType,
    PayTypeCheckList,
    PlatformTypeCheckList,
    ShippingAreaTypeSelect,
    TaskMessageSearchTypeSelect,
    CompSelectBox,
    PageTitle,
  },
  directives: {
    ClickOutside
  }
})
export default class ClaimContentTop extends Vue{
  @Getter('mall/malls')
  private malls: Mall[] // TODO: 지우기

  @Ref('platformTypeCheckList')
  PlatformTypeCheckListComponent!: PlatformTypeCheckList
  @Ref('payTypeCheckList')
  PayTypeCheckListComponent!: PayTypeCheckList
  @Ref('claimStatusCheckList')
  ClaimStatusCheckListComponent!: ClaimStatusCheckList
  @Ref('dateCalendar')
  SearchDateTypeComponent!: SearchDateType

  @Prop({required: true, default: 'CANCEL'})
  private searchFormType!: ClaimType

  @Emit('onSearchResult')
  onSearchResult(request: any){
    return request
  }
  private isDelayClicked = false;
  private initialFormData = {
    delay: false,
    claimType: this.searchFormType,
    mallNo: undefined, // 공용 컴포넌트의 '전체' 값이 undefined임
    partnerNo: null,
    orderRegisterType: undefined,
    memberGroupNo: undefined,
    keyword: '',
    includesReservation: true,
    searchType: 'ALL',
    startYmd: addDay(new Date(), -7),
    endYmd: getToday(),
    searchDateType: 'APPLY_YMDT',
    payTypes: [],
    claimStatusTypes: [],
    shippingAreaType: undefined,
    includesHoldDelivery: true,
    returnWayType: '',
    taskMessageSearchType: 'ALL',
    platformTypes: ['PC', 'MOBILE_WEB', 'MOBILE_APP'],
  }
  private formData = {
    ...this.initialFormData
  }

  private get isRefundSearchFormType(){
    return this.searchFormType === 'REFUND'
  }

  // TODO: 정리 필요
  private onSearch(page: string = '1', isDelaySearch:boolean = this.formData.delay){
    if(!this.validation()){
      return
    }

    if(typeof page !== 'string'){
      page = '1'
    }
    
    // NavigationDuplicated 방지용
    const query = this.$route.query;
    query['dataRefresh'] = Date.now().toString();

    if (!isDelaySearch) {
      this.$router
        .replace(this.$route.path)
        .then(({ query }) => {
          delete query['dataRefresh'];
        });
    }

    this.formData.delay = isDelaySearch
    this.isDelayClicked = isDelaySearch
  
    const request: any = {
      ...this.formData,
      page,
      // size,
    }

    if((this.$refs.payTypeCheckList as any).isPayTypeCheckedAll) {
      request.payTypes = ''
    } else {
      request.payTypes = request.payTypes.join(',')
    }
    request.mallNo = request.mallNo ? request.mallNo : ''
    request.claimStatusTypes = this.isRefundSearchFormType ? this.getRefundClaimStatusTypes(request.claimStatusTypes).join(',') : request.claimStatusTypes.join(',')
    request.platformTypes = request.platformTypes.join(',')

    this.onSearchResult(request)
  }

  private validation(): boolean{
    if(this.formData.payTypes.length === 0){
      alert(this.$t('CLAIM_CONTENT_TOP_CHECK_PAY_TYPE_VALIDATION_MESSAGE'))
      return false
    }

    if(this.formData.platformTypes.length === 0){
      alert(this.$t('CLAIM_CONTENT_TOP_CHECK_PLATFORM_TYPE_VALIDATION_MESSAGE'))
      return false
    }

    if(this.formData.claimStatusTypes.length === 0){
      alert(this.$t('CLAIM_CONTENT_TOP_CHECK_CLAIM_STATUS_VALIDATION_MESSAGE'))
      return false
    }

    return true
  }

  // '환불관리'와 '취소, 교환, 반품관리'의 claimStatusTypes 요청 방법이 다르다. 그래서 환불관리페이지에서는 아래 함수를 호출해야한다.
  private getRefundClaimStatusTypes(claimStatusTypes: string[]){
    if(!this.isRefundSearchFormType){
      return []
    }

    const refundClaimStatusGroup = {
      REQUEST: ['CANCEL_PROC_REQUEST_REFUND', 'EXCHANGE_PROC_REQUEST_REFUND', 'RETURN_PROC_REQUEST_REFUND'],
      WAITING: ['CANCEL_PROC_WAITING_REFUND', 'RETURN_PROC_WAITING_REFUND', 'EXCHANGE_PROC_WAITING_REFUND'],
      ADJUST_REQUESTED: ['RETURN_REFUND_AMT_ADJUST_REQUESTED'],
      DONE: ['CANCEL_DONE', 'EXCHANGE_DONE', 'EXCHANGE_DONE_REFUND_DONE', 'RETURN_DONE'],
    }

    return claimStatusTypes.reduce((acc, claimStatusType) => [...acc, ...refundClaimStatusGroup[claimStatusType]], [])
  }

  private onResetForm(){
    this.formData = {
      ...this.initialFormData
    };

    this.PlatformTypeCheckListComponent.reset();
    this.PayTypeCheckListComponent.reset();
    this.ClaimStatusCheckListComponent.reset();
    this.SearchDateTypeComponent.clickPeriod('1w')
  }

  private mounted(){
    this.init()
  }

  private async init(){
    await this.setFormDataWhenComeFromMain();
    await this.PayTypeCheckListComponent.fetchAndSetPayTypesCheckList();
    this.onSearch()
  }

  private setFormDataWhenComeFromMain(){
    if(this.$route.query.delay){
      this.formData.delay = true
    }

    if(this.$route.query.fromMain){
      this.SearchDateTypeComponent.clickPeriod('3m')

      switch (this.searchFormType){
        case 'CANCEL':
          this.formData.claimStatusTypes = ['CANCEL_REQUEST']
          break;
        case 'RETURN':
          this.formData.claimStatusTypes = ['RETURN_REQUEST', 'RETURN_PROC_BEFORE_RECEIVE']
          break;
        case 'EXCHANGE':
          this.formData.claimStatusTypes = ['EXCHANGE_REQUEST', 'EXCHANGE_PROC_BEFORE_RECEIVE']
          break;
      }
    }
  }
}
